import React from "react";
import { Switch } from "react-router-dom";
import PropTypes from "prop-types";

// Hooks
import useCases from "../hooks/useCases";
import useAuthorizedContent from "../hooks/useAuthorizedContent";
import useLoadIncidentTypes from "../hooks/useLoadIncidentTypes";

// Context
import { useFeatureFlags } from "../context/FeatureFlagsProvider";
import CaseSidePanelProvider from "../context/CaseSidePanelProvider";

// Routes
import RouteHandler from "./RouteHandler";

const CasesRoutes = ({ routes }) => {
  const { featureFlags } = useFeatureFlags();

  useCases();
  useAuthorizedContent();
  useLoadIncidentTypes();

  return (
    <CaseSidePanelProvider>
      <Switch>
        {routes.map(route => {
          if (route.featureFlag && !featureFlags[route.featureFlag])
            return null;
          return <RouteHandler key={route.id} {...route} />;
        })}
      </Switch>
    </CaseSidePanelProvider>
  );
};

CasesRoutes.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default CasesRoutes;
